module.exports = __webpack_public_path__ + "static/media/Icon4.f294cd48.png";